import { SpecialAttackTutorialLayer } from "./SpecialAttackTutorialLayer";
import { BoardContainer } from "./board-container/BoardContainer";
import { GUI } from "./gui/GUI";
import { HUD } from "./hud/HUD";
import { BattleManager } from "./BattleManager";
import { GameVars } from "../../GameVars";
import * as Anuto from "../../../engine/src";
import { GameOverLayer } from "./GameOverLayer";
import { WinLayer } from "./WinLayer";
import { PauseMenu } from "./PauseMenu";
import { FirstTutorialLayer } from "./FirstTutorialLayer";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class BattleScene extends Phaser.Scene {

    public static currentInstance: BattleScene;

    public hud: HUD;
    public gui: GUI;
    public boardContainer: BoardContainer;
    public pauseMenu: PauseMenu;

    constructor() {

        super("BattleScene");
        BattleScene.currentInstance = this;
    }

    public create(): void {

        GameVars.currentScene = this;

        this.cameras.main.setBackgroundColor(0x000000);

        BattleManager.init();

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        this.pauseMenu = new PauseMenu(this);
        this.add.existing(this.pauseMenu);

        if (GameVars.gameData.initialTutorial) {
            let firstTutorialLayer = new FirstTutorialLayer(this);
            this.add.existing(firstTutorialLayer);
        }

        if (GameVars.currentMapZone === 0) {
            if (GameVars.currentMapCount === 2 && !GameVars.gameData.specialAttacks[1]) {
                this.gui.onClickNextWave(-1);
            }
        }

        AudioManager.playSoundtrack("soundtrack", .25);
    }

    public update(time: number, delta: number): void {

        BattleManager.update(time, delta);

        this.boardContainer.update(time, delta);
        this.hud.update(time, delta);
        this.gui.update(time, delta);
    }

    public showBossLayer(id: string): void {

        this.hud.showBossLayer(id);
    }

    public onWaveOver(): void {

        this.hud.onWaveOver();
    }

    public showSelectTurret(x: number, y: number): void {

        this.gui.showSelectTurret(x, y);
    }

    public hideSelectTurret(): void {

        this.gui.hideSelectTurret();
    }

    public showTurretMenu(anutoTurret: Anuto.Turret): void {

        this.gui.showTurretMenu(anutoTurret);
    }

    public hideTurretMenu(): void {

        this.gui.hideTurretMenu();
    }

    public hideNextWave(): void {

        this.gui.hideNextWave();
    }

    public onSuicideSoldierAvailable(): void {

        this.gui.onSuicideSoldierAvailable();
    }

    public addSuicideSoldier(suicideSoldier: Anuto.SuicideSoldier): void {

        this.boardContainer.addSuicideSoldier(suicideSoldier);
        this.hud.onSuicideSoldierAdded();
    }

    public onFreezeAttackLaunched(): void {

        this.hud.onFreezeAttackLaunched();

        this.boardContainer.board.launchFreezeAttack();
    }

    public onFreezeAttackAvailable(): void {

        this.gui.onFreezeAttackAvailable();
    }

    public showSpecialAttack(type: number): void {

        BattleManager.pause();

        let specialAttackTutorialLayer = new SpecialAttackTutorialLayer(this, type);
        this.add.existing(specialAttackTutorialLayer);
    }

    public showGameOverLayer(): void {
        if (typeof window.GameSnacks !== "undefined") {
            window.GameSnacks.game.gameOver();
        }
        let gameOverLayer = new GameOverLayer(this);
        this.add.existing(gameOverLayer);

        BattleManager.hideTurretMenu();
        BattleManager.hideNextWave();

        if (this.pauseMenu.visible) {
            this.hidePauseMenu();
        }
    }

    public showWinLayer(): void {



        let winLayer = new WinLayer(this);
        this.add.existing(winLayer);

        BattleManager.hideTurretMenu();

        if (this.pauseMenu.visible) {
            this.hidePauseMenu();
        }

        AudioManager.stopSound("pig_running");
    }

    public showPauseMenu(): void {
        if (!this.pauseMenu) {
            return;
        }
        if (!this.pauseMenu.visible) {

            this.pauseMenu.visible = true;
            GameManager.writeGameData();
            BattleManager.pause();

            this.boardContainer.hideRangeCircles();
            BattleManager.hideTurretMenu();
            BattleManager.hideSelectTurret();
        } else {
            this.hidePauseMenu();
        }
    }

    public hidePauseMenu(): void {
        if (!this.pauseMenu) {
            return;
        }
        if (this.pauseMenu.visible) {
            BattleManager.resume();
            this.pauseMenu.visible = false;
        }
    }
}
